import React from 'react';
import { AppLink, AppLinkProps } from './app-link';

type AppExternalLinkProps = Omit<AppLinkProps, 'target' | 'rel'>;

/**
 * Reusable external link component that opens in a new tab
 *
 * Automatically opens in new tab with security attributes
 * Inherits styling from AppLink
 */
export const AppExternalLink: React.FC<AppExternalLinkProps> = (props) => {
	const { href, ...rest } = props;
	return <AppLink target="_blank" rel="noopener noreferrer" href={href as string} {...(rest as any)} />;
};
